import { render, staticRenderFns } from "./org-edit.vue?vue&type=template&id=28b951ac&scoped=true&"
import script from "./org-edit.vue?vue&type=script&lang=js&"
export * from "./org-edit.vue?vue&type=script&lang=js&"
import style0 from "./org-edit.vue?vue&type=style&index=0&id=28b951ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b951ac",
  null
  
)

export default component.exports